/**
 * Hàm chuyển một array sang object
 * @param {array}    array: một mảng cần chuyển đổi
 * @param {function} getKey: một function đầu vào là một thành phần trong mảng và trả về key cho thành phần đó
 *
 * @return {object} Trả về object được chuyển đổi
 */
export const getObjectFromArray = (array, getKey) => {
  const result = {}
  const arrayLength = array.length
  for (let index = 0; index < arrayLength; index++) {
    const element = array[index]
    const key = getKey(element)
    result[key] = element
  }
  return result
}

/**
 * Hàm chuyển một object (lấy từ hàm getObjectFromArray) về array
 * @param {object} object: một object cần chuyển
 *
 * @return {array} trả về mảng các giá trị của objectÏ
 */
export const getArrayFromObject = object => {
  const result = []
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const element = object[key]
      result.push(element)
    }
  }
  return result
}
